import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { InputRadioCheckboxProps } from "./InputBaseProps";

export default function InputRadioCheckbox({
    name,
    customClass,
    id,
    type,
    placeholder = "",
    inputValue,
    autoComplete,
    label,
    isError,
    isValid,
    errorMessage,
    onChange,
    checked = false,
    ...args
}: InputRadioCheckboxProps) {
    const [, setValue] = useState(inputValue ?? "");

    return (
        <>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type={type}
                        name={name}
                        id={id}
                        value={inputValue}
                        onChange={(e) => {
                            onChange(e);
                            setValue(e.target.value);
                        }}
                        checked={checked}
                    />
                    <label className="form-check-label" htmlFor={id}>
                        {label}
                    </label>
                </div>
                {isValid && (
                <span className="tick-validate right-position">
                    <SVG
                        className="tick-icon"
                        src="Assets/Images/Icons/tick-icon.svg"
                        width="16"
                        height="16"
                    />
                </span>
                )}
            {isError ? <label className="text-error">{errorMessage}</label> : ""}
        </>
    );
}
